import { useIntl } from 'react-intl';
import { Tag } from 'sonata-react-components';

import { QREnabledStyle } from './QREnabled.style';

import type { AdInterface } from 'sonata-static-storage/lib/schemas/ad/ad.schema';
import type { Creative } from 'sonata-static-storage/lib/schemas/creative/creative.schema';

type Props = {
  ad: AdInterface<string>;
  creative: Creative;
};

export function QREnabled({ ad, creative }: Readonly<Props>): JSX.Element {
  const { formatMessage } = useIntl();

  const isQREnabled = !!ad.adOptions?.qrConfig?.enabled;

  return (
    <QREnabledStyle className="qr">
      <Tag
        icon={{ webFont: isQREnabled ? 'fas fa-qrcode' : 'fas fa-ban' }}
        id={`adCreative_${creative?._id || ''}_tag`}
        status={isQREnabled ? 'ok' : 'default'}
      >
        {isQREnabled
          ? formatMessage({
              defaultMessage: 'QR Set',
              id: 'adCreativeQRColumn.enabled'
            })
          : formatMessage({
              defaultMessage: 'QR N/A',
              id: 'adCreativeQRColumn.disabled'
            })}
      </Tag>
    </QREnabledStyle>
  );
}
